import React, {useEffect, useState} from "react";

const CargoDescriptionInputBlock = (props) => {

    const {
        bolId,
        isChecked,
        selectedBolsArray,
        setSelectedBolsArray,
        isSelectedManCorrector,
        cargoDescriptionNowReadsCurrentMan,
        cargoDescriptionShouldReadsCurrentMan
    } = props;

    const [isCargoDescriptionNowReads, setCargoDescriptionNowReads] = useState('');
    const [isCargoDescriptionShouldRead, setCargoDescriptionShouldRead] = useState('');


    function removeCargoDescriptionFromArray(id) {
        const filteredAnswers = selectedBolsArray.filter(answer => answer.bolId !== id);
        setSelectedBolsArray(filteredAnswers);
    }

    useEffect(() => {

        const dataToAdd = {
            bolId: bolId,
            cargoDescriptionNowReads: isCargoDescriptionNowReads,
            cargoDescriptionShouldRead: isCargoDescriptionShouldRead
        }

        if (isChecked === true) {
            setSelectedBolsArray([...selectedBolsArray, dataToAdd])
        } else if (isChecked === false) {
            removeCargoDescriptionFromArray(bolId)
        }

    },[isChecked])

    return (
        <>
        <div className="create-doc-set-man-corrector-modal__table-input-block">
            <input
                className="create-doc-set-man-corrector-modal__table-input-cargoDescription"
                type={'text'}
                value={isSelectedManCorrector !== undefined ? cargoDescriptionNowReadsCurrentMan : isCargoDescriptionNowReads}
                onChange={(e) => setCargoDescriptionNowReads(e.currentTarget.value)}
                disabled={isChecked}
            />
            <input
                className="create-doc-set-man-corrector-modal__table-input-cargoDescription"
                type={'text'}
                value={isSelectedManCorrector !== undefined ? cargoDescriptionShouldReadsCurrentMan : isCargoDescriptionShouldRead}
                onChange={(e) => setCargoDescriptionShouldRead(e.currentTarget.value)}
                disabled={isChecked}
            />
        </div>
        </>
    )
}
export default CargoDescriptionInputBlock;